import { render, staticRenderFns } from "./ArpCadastradasTable.vue?vue&type=template&id=1986f246&scoped=true&"
import script from "./ArpCadastradasTable.vue?vue&type=script&lang=js&"
export * from "./ArpCadastradasTable.vue?vue&type=script&lang=js&"
import style0 from "./ArpCadastradasTable.vue?vue&type=style&index=0&id=1986f246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986f246",
  null
  
)

export default component.exports